import isEqual from "fast-deep-equal/es6";
import { create } from "zustand";
import { OmgevingService } from "../services/omgevingService";
import { FetchState } from "./util";

/** Een officiële bekendmaking uit het register van de omgevingsmonitor. */
export type Publicatie = {
  publicatieId: string;
  titel: string;
  url: string;
  soort: string;
  blad: string;
  creator: string;
  gemeente: string;
  gepubliceerdOp: string | null;
  geometrielabel: string;
  afstandMeter: number | null;
  /** Individuele toestemming of beleid. De monitor bepaalt dat, niet wij. */
  vergunning: boolean;
  /** `PROCEDURESTATUSSEN` van de monitor; nog niet geleverd (omgevingsmonitor#85). */
  procedurestatus?: string;
};

interface PublicatiesState {
  state?: FetchState;
  geometry?: GeoJSON.Geometry;
  publicaties?: Publicatie[];
  load: (geometry: GeoJSON.Geometry, force?: boolean) => void;
  clear: () => void;
}

/**
 * Los van de cube: die komt uit ca_reference en wordt per project gecachet,
 * dit komt uit de omgevingsmonitor en verandert dagelijks. Ze samenvoegen zou
 * betekenen dat een nieuwe bekendmaking pas zichtbaar wordt als de hele cube
 * ververst.
 *
 * De sleutel is de geometrie, niet een project: hetzelfde perceel levert
 * dezelfde lijst of je nu op /location kijkt, in een projectrapport of in de
 * kaveldrawer. Vergelijken gaat met `fast-deep-equal`, zoals de cube-store
 * dat met zijn coördinaten doet.
 */
export const usePublicaties = create<PublicatiesState>((set, get) => ({
  load: async (geometry: GeoJSON.Geometry, force?: boolean) => {
    const cur = get();
    if (!force && isEqual(cur.geometry, geometry) && cur.state === "fetched") return;
    set({ geometry, state: "fetching", publicaties: undefined });
    try {
      const publicaties = await OmgevingService.publicaties(geometry);
      // Een ander perceel geselecteerd terwijl dit antwoord onderweg was.
      if (isEqual(get().geometry, geometry)) set({ state: "fetched", publicaties });
    } catch {
      if (isEqual(get().geometry, geometry)) set({ state: "error" });
    }
  },
  clear: () => set({ state: undefined, geometry: undefined, publicaties: undefined }),
}));
